import { MarketIdToMarketType } from "../../../helpers";
export const marketsFilter = (outrightEventIds) => {
    const marketTypeFilter = `$filter=marketType/id in(${Object.keys(MarketIdToMarketType).map(id => `'${id}'`).join(",")})`;
    if (outrightEventIds.length === 0) {
        return marketTypeFilter;
    }
    const outrightEventsFilter = `or eventId in(${outrightEventIds.map(id => `'${id}'`).join(",")})`;
    return `${marketTypeFilter}${outrightEventsFilter}`;
};
//# sourceMappingURL=marketsFilter.js.map